module.exports = "/9a61ce498d79a3386d51504cc3d8ef28.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/brands/udder-belly.png
 ** module id = 2210
 ** module chunks = 0
 **/